import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../../services/central-api/dispatch';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { translate } from '../../../services/translate';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../../components/FormDropDownPicker';

type Props = {
    includeAllOption: boolean;
    disabled?: boolean;
    zIndex: number;
    labelFontSize?: number;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function ActingBodiesDropdown({ value, setValue, zIndex, disabled, includeAllOption, labelFontSize, form, fieldName }: Props) {
    const [selectableActingBodies, setSelectableActingBodies] = useState<{ label: string; value: number; }[]>([]);

    async function getActingBodies() {
        try {
            const actingBodies = await dispatchService.getActingBodies();
            setSelectableActingBodies([
                ...(includeAllOption ? [{ value: 0, label: translate('masculineAll') }] : []),
                ...actingBodies.map((actingBody) => ({
                    value: actingBody.id,
                    label: actingBody.name
                }))
            ]);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getActingBodies();
    }, []);

    if (form && fieldName) {
        return (
            <FormDropDownPicker
                label={translate('actingBody')}
                items={selectableActingBodies}
                zIndex={zIndex}
                disabled={disabled}
                labelFontSize={labelFontSize}
                fieldName={fieldName}
                form={form}
                multiple={false}
            />
        );
    }

    return (
        <FilterDropdown
            label={translate('actingBody')}
            items={selectableActingBodies}
            labelFontSize={labelFontSize}
            multiple={false}
            setValue={setValue!}
            value={value!}
            zIndex={zIndex}
            disabled={disabled}
        />
    );
}

export default ActingBodiesDropdown;
